const isMissing = (value) => value === null || value === undefined || value === ''

const compareValues = (first, next) => {
    if (Array.isArray(first)) {
        return first.reduce((result, value, index) => result || compareValues(value, next?.[index]), 0)
    }
    if (isMissing(first) || isMissing(next)) {
        return isMissing(first) - isMissing(next)
    }
    if (typeof first === 'string') {
        return first.localeCompare(String(next), undefined, { numeric: true, sensitivity: 'base' })
    }
    if (first < next) return -1
    if (first > next) return 1
    return 0
}

/**
 * Builds a comparator for sorting table rows by one column.
 *
 * Missing values (null, undefined or '') always sort last, whichever way the column is sorted.
 * Strings compare case-insensitively, with numbers inside them in number order. Arrays compare
 * element by element, so a column can sort by a main value and then a tie-breaker.
 *
 * @param {'asc' | 'desc'} order - Sort direction
 * @param {(row: Object) => *} getValue - Reads the value to sort by from a row
 * @returns {(a: Object, b: Object) => number} Comparator for Array.prototype.sort
 */
export const getSortComparator = (order, getValue) => (a, b) => {
    const first = getValue(a)
    const next = getValue(b)

    if (isMissing(first) || isMissing(next)) {
        return isMissing(first) - isMissing(next)
    }

    const result = compareValues(first, next)
    return order === 'desc' ? -result : result
}
